export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      padding: '15px 15px 0'
    },
    icon: {
      margin: '10px auto 0',
      '& svg': {
        maxHeight: '80px',
        fill: colors.titleIconsColor
      }
    }
  };
});